/**
 * Count Card Widget - Muestra un conteo con etiqueta
 *
 * Widget para mostrar métricas de conteo simples.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { WidgetWrapper } from './WidgetWrapper';

export interface CountCardProps {
  title: string;
  count: number;
  entityName?: string;
  loading?: boolean;
  computing?: boolean;
  error?: string | null;
  onRefresh?: () => void;
  icon?: React.ReactNode;
  color?: string;
}

export const CountCard: React.FC<CountCardProps> = ({
  title,
  count,
  entityName,
  loading = false,
  computing = false,
  error = null,
  onRefresh,
  icon,
  color = 'primary.main',
}) => {
  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toLocaleString();
  };

  return (
    <WidgetWrapper
      title={title}
      loading={loading}
      computing={computing}
      error={error}
      onRefresh={onRefresh}
      icon={icon}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 2,
        }}
      >
        <Typography
          variant="h2"
          component="span"
          sx={{
            fontWeight: 'bold',
            color,
            lineHeight: 1,
          }}
        >
          {formatNumber(count)}
        </Typography>
        {entityName && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {entityName}
          </Typography>
        )}
      </Box>
    </WidgetWrapper>
  );
};

export default CountCard;
